import styled from 'styled-components';

// Fills the viewport so the footer sits at the bottom of short screens
export const Page = styled.div`
  display: flex;
  flex-direction: column;
  min-height: calc(var(--vh, 1svh) * 100);
`;

// Column box, so a screen with flex-grow can fill the space above the footer
export const Main = styled.div`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
`;
